import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { useUserStore } from '@/stores/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'Cabinet',
  props: ['textPages', 'isHijacked', 'hijackedReleaseLink'],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props
const store = useUserStore()
const profile = computed(() => store.profile)
const { $t } = useGlobal()
const hideAttansion = ref(false)

const __returned__ = { props, store, profile, $t, hideAttansion, ref, computed, get useGlobal() { return useGlobal }, get useUserStore() { return useUserStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})